<template lang="pug">
.external-equity-container(
)
  .header {{moduleTitle}}
  .body
    .body-block(v-for="(item, index) in equityList")
      .body-item(@click="goOther(item)")
        img(:src="item.imgUrl")
    .body-two-block(v-for="(item, index) in equityListTwo")
      .body-item(@click="goOther(item)")
        img(:src="item.imgUrl")
</template>

<script>
import { externalEquity } from '@/api/bounty';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  data() {
    return {
      pageSize: 5,
      pageNums: [],
      active: 0,
      info: [],
      hasMore: [],
      loading: false,
      equityList: [],
      equityListTwo: [],
    };
  },
  computed: {
    moduleTitle() {
      return '天天领福利';
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const res = await externalEquity();
        if (res.data) {
          if (Array.isArray(res.data.bountyExternalEquities)) {
            this.equityList = res.data.bountyExternalEquities.slice(0, 2);
            this.equityListTwo = res.data.bountyExternalEquities.slice(2, res.data.length);
          }
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'platform_cps',
            contentId: 'platform_cps',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    goOther(item) {
      window.location.href = item.skipUrl;
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'platform_cps',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.external-equity-container {
  padding: 0.2rem 0.16rem 0.11rem 0.16rem;

  .header {
    font-size: 0.18rem;
    color: #242729;
    margin-bottom: 0.08rem;
    font-weight: 500;
  }

  .body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.05rem;

    .body-block {
      img {
        width: 1.54rem;
        height: 0.86rem;
      }
    }

    .body-two-block {
      margin-top: 0.07rem;

      img {
        width: 1.54rem;
        height: 1.67rem;
      }
    }
  }
}
</style>
